import React from 'react';
import { Paper, styled, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Edit from '@mui/icons-material/Edit';
import clsx from 'clsx';
import { IconButton } from 'ui/buttons/IconButton';
import { Column, Row } from 'ui/Flex';
import { CampaignDefineFormData } from './forms/CreateCampaignDefine';

interface DefineTextViewProps {
    defineData: CampaignDefineFormData;
}

const DefineTextView: React.FC<DefineTextViewProps> = ({ defineData }) => (
    <Typography variant="body2" color="textSecondary">
        The campaign will be visible as <b>{defineData.title}</b> in your campaign list.
        <br />
        {defineData.description && (
            <>
                This campaign had the description of{' '}
                <Typography component="span" variant="body2" color="textSecondary">
                    <b>{defineData.description}</b>
                </Typography>
            </>
        )}
    </Typography>
);

const PREFIX = 'CampaignDefineView';

const classes = {
    root: `${PREFIX}-root`,
    icon: `${PREFIX}-icon`,
    column: `${PREFIX}-column`,
    button: `${PREFIX}-button`
};

const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(4, 4, 5, 3),
    position: 'relative',
    [`& .${classes.icon}`]: {
        paddingRight: theme.spacing(2),
        paddingTop: theme.spacing(1)
    },
    [`& .${classes.column}`]: {
        paddingRight: theme.spacing(3)
    },
    [`& .${classes.button}`]: {
        position: 'absolute',
        top: theme.spacing(1),
        right: theme.spacing(1)
    }
}));

type CampaignDefineViewProps = DefineTextViewProps & {
    className?: string;
    onEdit: () => void;
};

export const CampaignDefineView: React.FC<CampaignDefineViewProps> = props => {
    const { defineData, className, onEdit } = props;

    return (
        <StyledPaper className={clsx(classes.root, className)}>
            <Row flex={1} align="space-between" valign="flex-start">
                <div className={classes.icon}>
                    <CheckCircleIcon color="primary" />
                </div>
                <Column flex={1} className={classes.column}>
                    <Typography variant="h5">Define</Typography>
                    <DefineTextView defineData={defineData} />
                </Column>
            </Row>
            <IconButton className={classes.button} onClick={onEdit} size="large">
                <Edit />
            </IconButton>
        </StyledPaper>
    );
};
